import axios from 'axios';
import ENV from "../config";
const getCountry =  async(param1) => {
  try {
    const response = await axios.get(ENV.backend+ '/api/country', {
  
     // params: {
       
       // companyName: param1
      //},
    });

    if (response.status === 200) {
      console.log(response.data)
      return response.data;
    } else {
      throw new Error('Failed to retrieve country objects');
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default getCountry;
